import Base2Repository from "./base2.repository";
import { GenericService } from "core/data/service";
import axios from "axios";
import { getBaseAPIEstoka } from "../../util/get-base-api";

class Oms extends Base2Repository {
  getServiceProvider() {
    return new GenericService({
      create: "/v1/oms_integrations",
      update: "/v1/oms_integrations"
    });
  }

  async getOms(company_uuid) {
    return await this.get(`/v1/companies/${company_uuid}/oms_integrations`);
  }

  async createOms(params) {
    return await this.create({
      account_uuid: params.account_uuid,
      company_uuid: params.company_uuid,
      organization_id: parseInt(params.organization_id, 10),
      organization_name: params.organization_name,
      stock_id: parseInt(params.stock_id, 10),
      stock_name: params.stock_name,
      sale_channel_id: parseInt(params.sale_channel_id, 10),
      sale_channel_name: params.sale_channel_name,
      token: params.token,
      enabled: true
    });
  }

  async updateOms(uuid, params) {
    return await this.update(uuid, {
      account_uuid: params.account_uuid,
      company_uuid: params.company_uuid,
      organization_id: parseInt(params.organization_id, 10),
      organization_name: params.organization_name,
      stock_id: parseInt(params.stock_id, 10),
      stock_name: params.stock_name,
      sale_channel_id: parseInt(params.sale_channel_id, 10),
      sale_channel_name: params.sale_channel_name,
      token: params.token,
      enabled: params.enabled
    });
  }

  async fetchOrganizations(token) {
    const apiEstoka = getBaseAPIEstoka()
    const url = `${apiEstoka}/api/v1/organizations `;
    const headers = {
      "Access-Control-Allow-Origin": "*",
      authorization: `Token token=${token}`
    };

    try {
      return await axios.get(url, { headers });
    } catch (error) {
      return error;
    }
  }

  async fetchStocks(token, organizationID) {
    const apiEstoka = getBaseAPIEstoka()
    const url = `${apiEstoka}/api/v1/organizations/${organizationID}/stocks `;
    const headers = {
      "Access-Control-Allow-Origin": "*",
      authorization: `Token token=${token}`,
      mode: "no-cors"
    };

    try {
      return await axios.get(url, { headers });
    } catch (error) {
      return error;
    }
  }
}

export default new Oms();



// WEBPACK FOOTER //
// ./src/core/repository/oms.repository.js